export const brand = {
  blue: '#0052D9',
  blueHover: '#0046B8',
  blueActive: '#003D99',
  blueSoft: '#EAF2FF',
  green: '#79C000',
  greenText: '#4D7900',
  greenSoft: '#F1F8E6',
  page: '#F4F6F8',
  pageSubtle: '#F9FAFB',
  ink: '#172033',
  textSecondary: '#4B5568',
  border: '#DCE3EB',
} as const;
